// @flow
import * as React from 'react';
import styles from './SocialCounts.less';

type Props = {|
  children: React.Node,
|};

const SocialCounts = ({ children }: Props) => (
  <div className={styles.counts_list}>
    {React.Children.map(children, child =>
      child ? (
        <span key={child.key} className={styles.counts}>
          {child}
        </span>
      ) : null,
    )}
  </div>
);

export default SocialCounts;
